import BaseError from "@/error";
import { isMonthIndex, MonthIndex } from "@/typing";
export default class MonthPeriod {
  monthIndex: MonthIndex;
  year: number;
  constructor(year: number, monthIndex: MonthIndex) {
    this.monthIndex = monthIndex;
    this.year = year;
  }

  public toString(): string {
    return `${this.year}-${this.monthIndex}`;
  }

  public toYMStr(): string {
    return this.toString();
  }

  public toMYStr(): string {
    return `${this.monthIndex}-${this.year}`;
  }

  public toMYSlashStr(): string {
    return `${this.monthIndex}/${this.year}`;
  }

  public eq(other: MonthPeriod): boolean {
    return this.year == other.year && this.monthIndex == other.monthIndex;
  }

  /**
   * Creates a MonthPeriod from a string with format `Y-m`.
   *
   * @throws InvalidMonthPeriodStr if the string is not in the format `Y-m`.
   */
  public static fromStr(periodStr: string): MonthPeriod {
    const [year, month] = MonthPeriod._getComponentsFromStr(periodStr);

    if (!isMonthIndex(month)) {
      throw new InvalidMonthPeriodStr(periodStr);
    }

    return new MonthPeriod(year, month);
  }

  /**
   * Creates a MonthPeriod from a string with format `Y-m`.
   *
   * @throws InvalidMonthPeriodStr if the string is not in the format `Y-m`.
   */
  public static fromMYStr(periodStr: string): MonthPeriod {
    const [month, year] = MonthPeriod._getComponentsFromStr(periodStr);

    if (!isMonthIndex(month)) {
      throw new InvalidMonthPeriodStr(periodStr);
    }

    return new MonthPeriod(year, month);
  }

  private static _getComponentsFromStr(str: string): number[] {
    const components = str.split("-");

    if (components.length !== 2) {
      throw new InvalidMonthPeriodStr(str);
    }

    const componentsNum = components.map((e) => parseInt(e, 10));

    if (componentsNum.some(isNaN)) {
      throw new InvalidMonthPeriodStr(str);
    }
    return componentsNum;
  }
}

export class InvalidMonthPeriodStr extends BaseError {
  readonly name = "InvalidMonthPeriodStr";

  constructor(invalidStr: string) {
    super(`The string "${invalidStr}" is not a valid MonthPeriod.`);
  }
}
